import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

import type { RetailBannerItems } from './retailLinesheetsBanner.hooks'
import {
  CONTENT_TYPES,
  useRetailLinesheetBannerContentful,
} from './retailLinesheetsBanner.hooks'
import { formatPhpLinesheetsPage } from './retailLinesheetsBanner.utils'
import { Carousel } from 'features/Carousel'
import { RetailerBannerItem } from 'features/Contentful/RetailerBannerItem/RetailerBannerItem'

const BannerContainer = styled.div`
  position: absolute;
  top: -57px;
  left: max(calc((100% - 1024px) / 2), 0px);
  width: 1024px;
  z-index: 1000;
  padding: 8px;
`

const getItems = (banners: RetailBannerItems[]) =>
  banners.map((banner: RetailBannerItems, index: number) => (
    <RetailerBannerItem key={index} {...banner} smallBannerImage />
  ))

const RetailLinesheetsBanner = () => {
  const location = useLocation()
  const isRetailerLinesheetPage =
    location.pathname.includes('/collections/shop')
  const { data, isLoading, isError } = useRetailLinesheetBannerContentful(
    CONTENT_TYPES.RETAIL_BANNER,
    isRetailerLinesheetPage,
  )

  if (isRetailerLinesheetPage && !isLoading && !isError && data.length > 0) {
    const isValidPage = formatPhpLinesheetsPage()

    if (isValidPage) {
      return (
        <BannerContainer>
          <Carousel isSmallContainer items={getItems(data)} />
        </BannerContainer>
      )
    }
  }

  return null
}

export default RetailLinesheetsBanner
